import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Banner extends Component{
    render() {
        const{imageUrl, icon, licenceType, secondClassname, vehicleType, text } = this.props;
        if (icon){
            return (
                    <div className={`div-titulo px-3 mx-0 ${secondClassname ? secondClassname + '' : null}`}
                         style={{
                             paddingTop: "2vh",
                             marginRight: "0px",
                             backgroundImage: `url(${imageUrl})`,
                             height: window.innerWidth >= 768
                                 ? "40vh"
                                 : window.innerHeight >= 736
                                     ? "65vh"
                                     : window.innerHeight <= 600
                                          ? "80vh"
                                         : "70vh"
                         }}>
                        <div className={`row ${window.innerHeight <= 600 ? "pt-0": "pt-5"}`}>
                            <div className="col-md-2"></div>
                            <div className="col-md-2">
                                    {
                                        licenceType.length > 3 && window.innerWidth >= 768
                                            ? <p className="font-weight-bold text-md-left text-center text-white letra-titulo-licencia pt-5 pl-0 ml-0" style={{
                                                transform: 'scale(0.5)',
                                            }}>
                                                { licenceType } <br/>
                                            </p>
                                            :<p className="font-weight-bold text-md-left text-center text-white letra-titulo-licencia" style={{
                                                marginTop: "4vh",
                                            }}>{ licenceType }</p>
                                    }
                            </div>
                            <div className={ `${window.innerWidth <= 768 ? "text-center ":""} col-md-6 mt-md-5 ml-md-0 ${!(!!text) && window.innerWidth >= 768
                                ? "pt-4"
                                : ""}`} style={{
                                alignItems: "center"
                            }}>
                                {
                                    icon ? <img src={ icon } width="50" height="50" alt={icon || "icono"}/> : null
                                }
                                <p className="font-weight-bold text-white">{ vehicleType }</p>
                                <p className="text-white text-justify">{ text }</p>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
            );
        } else{
            return(
                <div className="div-titulo px-3 mx-0 pt-4" style={{
                    marginRight: "0px",
                    backgroundImage: `url(${imageUrl})`,
                    height: window.innerWidth >= 768 ? "40vh" : "65vh"
                }}>
                    <div className="text-header-sm div-titulo">
                        <h2 className="text-white text-center text-md-left" style={{
                            alignItems: "center",
                            marginTop: "15vh",
                            paddingLeft: window.innerWidth >= 768 ? "20vh": ""
                        }}>{ vehicleType }</h2>
                    </div>
                </div>
            );
        }

    }
}

Banner.propTypes = {
    imageUrl: PropTypes.string,
    text: PropTypes.string,
    licenceType: PropTypes.string,
    vehicleType: PropTypes.string,
    icon: PropTypes.string,
    secondClassname: PropTypes.string
};

export default Banner;
